export const sidebarLinks = [
    {
        imgURL: '/icons/home.svg',
        route: '/',
        label: 'Home',
    },
    {
        imgURL: '/icons/info.svg',
        route: '/about',
        label: 'About',
    },
    {
        imgURL: '/icons/news.svg',
        route: '/news',
        label: 'News',
    },
    {
        imgURL: '/icons/blog.svg',
        route: '/blog',
        label: 'Blog',
    },
    {
        imgURL: '/icons/contact.svg',
        route: '/contact',
        label: 'Contact',
    },
]

export const FOLDERS = {
    PUBLIC_UPLOADS_TEMPFILES: 'public/uploads/tempfiles',
    PUBLIC_UPLOADS_POST: 'public/uploads/post',
    UPLOADS_POST: 'uploads/post',
}

export const COOKIES = {
    TOAST_MESSAGE: 'toast-message',
}

export const RECAPTCHA_ACTIONS = {
    CONTACT_FORM: 'contact_form',
    NEWSLETTER_FORM: 'newsletter_form',
    SIGN_UP: 'sign_up',
    SIGN_IN: 'sign_in',
}
